// /** @format */

import React, { useState } from "react";
import "./WeatherMap.css";

import forecast from "../../Data/forecast.json";
import sunData from "../../Data/sunpath_new1.json";

const { maxTempr, minTempr } = forecast[0];
const [timestamp, sunrise, sunset] = sunData.sunrise_sunset[0];

const date = new Date(timestamp);
const WeatherMap = ({ selectedZone }) => {
 
  const locationData = {
    SZone: {
      name: "Thoothukudi",
      temp: "33°C",
      elevation: "550m",
      precipitation: "700mm",
    },
    WZone: {
      name: "Thoothukudi",
      temp: "28°C",
      elevation: "430m",
      precipitation: "850mm",
    },
  };

   const [sunPath, setSunPath] = useState(null);
  const currentLocation = locationData[selectedZone];


  return (
    <div className="weather-map">
      <div className="map-container">
        <div className="map-overlay">
          <div className="location-popup">
            <div className="popup-header">
              <span className="zone-indicator">
                📍 {selectedZone || "No Zone"}
              </span>
             
            </div>
            <div className="popup-content">
              <div className="location-name">{currentLocation.name}</div>
              <div className="temp-display">{currentLocation.temp}</div>
              <div className="location-details">
                <div>Elevation: {currentLocation.elevation}</div>
                <div>Precipitation: {currentLocation.precipitation}</div>
              </div>
            </div>
          </div>
        </div>

        <div className="map-placeholder">
          <div className="map-grid">
            {Array.from({ length: 20 }).map((_, i) => (
              <div key={i} className="grid-line"></div>
            ))}
          </div>
          <div
            className="location-marker"
            style={{
              left: selectedZone === "SZone" ? "70%" : "40%",
              top: selectedZone === "SZone" ? "60%" : "45%",
            }}>
            <div className="marker-pulse"></div>
            <div className="marker-dot"></div>
          </div>
        </div>

        <button
          className={`sun-path-toggle ${sunPath ? "active" : ""}`}
          onClick={() => setSunPath(!sunPath)}>
          TOGGLE SUN PATH
        </button>
      </div>

      <div className="map-attribution">
        {/* <span>🗺️ Leaflet</span> */}
        <div>
          <h3>Details</h3>
          <p>Min Temp: {minTempr}°C</p>
          <p>Max Temp: {maxTempr}°C</p>
          <p>Sunrise: {sunrise.toFixed(2)} hrs</p>
          <p>Sunset: {sunset.toFixed(2)} hrs</p>
          <p>
            TimeStamp: {date.getDate()}/{date.getDay()}/{date.getFullYear()}
          </p>
        </div>
      </div>
    </div>
  );
};

export default WeatherMap;
// import React, { useState, useEffect, useRef } from 'react';
// import SunPathService from '../../Data/sunpath_new1.json';
// import './WeatherMap.css';

// const WeatherMap = () => {
//   const mapRef = useRef(null);
//   const [map, setMap] = useState(null);
//   const [currentLocation, setCurrentLocation] = useState({ lat: 11.0168, lng: 76.9558 }); // Coimbatore
//   const [sunPathData, setSunPathData] = useState(null);
//   const [showSunPath, setShowSunPath] = useState(false);
//   const [selectedDate, setSelectedDate] = useState(new Date());
//   const [sunPathOverlay, setSunPathOverlay] = useState(null);

//   useEffect(() => {
//     initializeMap();
//     loadSunPathData();
//   }, []);

//   useEffect(() => {
//     if (map && sunPathData) {
//       updateSunPathOverlay();
//     }
//   }, [map, sunPathData, selectedDate, showSunPath]);

//   const loadSunPathData = async () => {
//     try {
//       const data = await SunPathService.loadData();
//       setSunPathData(data);
//     } catch (error) {
//       console.error('Failed to load sun path data:', error);
//     }
//   };

//   const initializeMap = () => {
//     // Initialize with a simple div-based map for demonstration
//     // In production, you would use a proper map library like Leaflet or Google Maps
//     const mapContainer = mapRef.current;
//     if (mapContainer) {
//       setMap({
//         container: mapContainer,
//         center: currentLocation,
//         zoom: 12
//       });
//     }


// WeatherMap.js
// WeatherMap.js
// import React, { useState, useEffect, useRef } from "react";
// import L from "leaflet";
// import SunPathService from "../../Data/sunpath_new1.json";
// import "./WeatherMap.css";

// const WeatherMap = () => {
//   const mapRef = useRef(null); // DOM container for Leaflet
//   const leafletMapRef = useRef(null); // Leaflet map instance
//   const [currentLocation, setCurrentLocation] = useState({
//     lat: 11.0168,
//     lng: 76.9558,
//   }); // Coimbatore default
//   const [sunPathData, setSunPathData] = useState(null);
//   const [showSunPath, setShowSunPath] = useState(false);
//   const [selectedDate, setSelectedDate] = useState(new Date());

//   useEffect(() => {
//     initializeMap();
//     loadSunPathData();

//     return () => {
//       // Cleanup on unmount
//       if (leafletMapRef.current) {
//         leafletMapRef.current.remove();
//         leafletMapRef.current = null;
//       }
//     };
//   }, []);

//   useEffect(() => {
//     if (leafletMapRef.current && sunPathData) {
//       updateSunPathOverlay();
//     }
//   }, [sunPathData, selectedDate, showSunPath]);

//   const loadSunPathData = async () => {
//     try {
//       // Since you have a static JSON, no fetch is needed
//       setSunPathData(SunPathService);
//     } catch (error) {
//       console.error("Failed to load sun path data:", error);
//     }
//   };

//   const initializeMap = () => {
//     if (!mapRef.current) return;

//     // Remove previous map instance if exists
//     if (leafletMapRef.current) {
//       leafletMapRef.current.remove();
//     }

//     const map = L.map(mapRef.current).setView(
//       [currentLocation.lat, currentLocation.lng],
//       12
//     );

//     L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
//       attribution:
//         '&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a>',
//     }).addTo(map);

//     L.marker([currentLocation.lat, currentLocation.lng])
//       .addTo(map)
//       .bindPopup("Current Location");

//     leafletMapRef.current = map;
//   };

//   const updateSunPathOverlay = () => {
//     if (!showSunPath || !sunPathData) return;

//     const dateKey = selectedDate.toISOString().split("T")[0];
//     const dayData = sunPathData[dateKey];

//     if (dayData && dayData.coordinates) {
//       const latlngs = dayData.coordinates.map((coord) => [
//         coord.lat,
//         coord.lng,
//       ]);

//       L.polyline(latlngs, { color: "orange" }).addTo(leafletMapRef.current);
//     }
//   };

//   return (
//     <div className="weather-map-container">
//       <div className="controls">
//         <input
//           type="date"
//           value={selectedDate.toISOString().split("T")[0]}
//           onChange={(e) => setSelectedDate(new Date(e.target.value))}
//         />
//         <label>
//           <input
//             type="checkbox"
//             checked={showSunPath}
//             onChange={() => setShowSunPath(!showSunPath)}
//           />{" "}
//           Show Sun Path
//         </label>
//       </div>
//       <div ref={mapRef} className="map" style={{ height: "500px" }}></div>
//     </div>
//   );
// };

// export default WeatherMap;
// WeatherMap.js
// import React, { useState, useEffect, useRef } from "react";
// import * as L from "leaflet";
// import ShadeMap from "leaflet-shadow-simulator";
// import "./WeatherMap.css";

// const WeatherMap = () => {
//   const mapRef = useRef(null);
//   const leafletMapRef = useRef(null);
//   const weatherMarkerRef = useRef(null);
//   const shadeMapRef = useRef(null);

//   const [currentLocation] = useState({ lat: 11.0168, lng: 76.9558 });
//   const [showShadow, setShowShadow] = useState(false);
//   const [showSunPath, setShowSunPath] = useState(false);
//   const [weatherData, setWeatherData] = useState(null);

//   const API_KEY = process.env.API_KEY_SHADOW; // for weather only

//   useEffect(() => {
//     initializeMap();
//     getWeatherData(currentLocation.lat, currentLocation.lng);

//     return () => {
//       if (leafletMapRef.current) {
//         leafletMapRef.current.remove();
//         leafletMapRef.current = null;
//       }
//     };
//   }, []);

//   useEffect(() => {
//     if (showShadow) {
//       addShadeMap();
//     } else {
//       removeShadeMap();
//     }
//   }, [showShadow]);

//   const initializeMap = () => {
//     if (!mapRef.current) return;

//     if (leafletMapRef.current) {
//       leafletMapRef.current.remove();
//     }

//     const map = L.map(mapRef.current).setView(
//       [currentLocation.lat, currentLocation.lng],
//       15
//     );

//     L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
//       attribution:
//         '&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a>',
//     }).addTo(map);

//     leafletMapRef.current = map;
//   };

//   const getWeatherData = async (lat, lon) => {
//     try {
//       const res = await fetch(
//         `https://api.openweathermap.org/data/2.5/weather?lat=${lat}&lon=${lon}&units=metric&appid=${API_KEY}`
//       );
//       const data = await res.json();
//       setWeatherData({
//         temp: data.main.temp,
//         humidity: data.main.humidity,
//         description: data.weather[0].description,
//       });

//       if (leafletMapRef.current) {
//         if (weatherMarkerRef.current) {
//           leafletMapRef.current.removeLayer(weatherMarkerRef.current);
//         }
//         const marker = L.marker([lat, lon]).addTo(leafletMapRef.current);
//         marker.bindPopup(
//           `<b>Weather:</b> ${data.weather[0].description}<br>
//            🌡 Temp: ${data.main.temp}°C<br>
//            💧 Humidity: ${data.main.humidity}%`
//         );
//         weatherMarkerRef.current = marker;
//       }
//     } catch (err) {
//       console.error("Weather fetch failed:", err);
//     }
//   };

//   const addShadeMap = () => {
//     if (!leafletMapRef.current || shadeMapRef.current) return;

//     const shadeMap = new ShadeMap({
//       date: new Date(),
//       color: "#01112f",
//       opacity: 0.7,
//       terrainSource: {
//         tileSize: 256,
//         maxZoom: 15,
//         getSourceUrl: ({ x, y, z }) =>
//           `https://s3.amazonaws.com/elevation-tiles-prod/terrarium/${z}/${x}/${y}.png`,
//         getElevation: ({ r, g, b }) =>
//           r * 256 + g + b / 256 - 32768,
//       },
//     });

//     shadeMap.addTo(leafletMapRef.current);
//     shadeMapRef.current = shadeMap;
//   };

//   const removeShadeMap = () => {
//     if (leafletMapRef.current && shadeMapRef.current) {
//       leafletMapRef.current.removeLayer(shadeMapRef.current);
//       shadeMapRef.current = null;
//     }
//   };

//   return (
//     <div className="weather-map-container">
//       <div className="controls">
//         <label>
//           <input
//             type="checkbox"
//             checked={showShadow}
//             onChange={() => setShowShadow(!showShadow)}
//           />{" "}
//           Show Shadow Simulation
//         </label>
//         <label>
//           <input
//             type="checkbox"
//             checked={showSunPath}
//             onChange={() => setShowSunPath(!showSunPath)}
//           />{" "}
//           Show Sun Path
//         </label>
//       </div>

//       {weatherData && (
//         <div className="weather-info">
//           <p>
//             <b>{weatherData.description}</b> | 🌡 {weatherData.temp}°C | 💧{" "}
//             {weatherData.humidity}%
//           </p>
//         </div>
//       )}

//       <div ref={mapRef} className="map" style={{ height: "500px" }}></div>
//     </div>
//   );
// };

// export default WeatherMap;
// import React, { useEffect } from 'react';
// import L from 'leaflet';
// import ShadeMap from 'leaflet-shadow-simulator';
// import 'leaflet/dist/leaflet.css';

// const WeatherMap = () => {
//   useEffect(() => {
//     const map = L.map('mapid').setView([13.0827, 80.2707], 13);

//     L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
//       maxZoom: 19,
//       attribution: '&copy; OpenStreetMap contributors'
//     }).addTo(map);

//     const shadeMap = new ShadeMap({
//       date: new Date(),
//       color: '#01112f',
//       opacity: 0.7,
//       apiKey:"",
//       apiKey: process.env.API_KEY_SHADOW,
//       terrainSource: {
//         tileSize: 256,
//         maxZoom: 15,
//         getSourceUrl: ({ x, y, z }) =>
//           `https://s3.amazonaws.com/elevation-tiles-prod/terrarium/${z}/${x}/${y}.png`,
//         getElevation: ({ r, g, b }) =>
//           (r * 256 + g + b / 256) - 32768
//       }
//     }).addTo(map);

//     // Toggle sunpath example
//     const toggleSunpath = () => {
//       const nextHour = new Date(Date.now() + 1000 * 60 * 60);
//       shadeMap.setDate(nextHour);
//     };

//     document.getElementById('toggleSunpathBtn').addEventListener('click', toggleSunpath);

//     return () => {
//       map.remove();
//     };
//   }, []);

//   return (
//     <div style={{ position: 'relative', width: '100%', height: '100%' }}>
//       <div id="mapid" style={{ height: '500px', borderRadius: '12px', overflow: 'hidden' }}></div>
//       <button
//         id="toggleSunpathBtn"
//         style={{
//           position: 'absolute',
//           top: '10px',
//           right: '10px',
//           padding: '8px 12px',
//           backgroundColor: '#fff',
//           border: '1px solid #ccc',
//           borderRadius: '6px',
//           cursor: 'pointer'
//         }}
//       >
//         Toggle Sunpath
//       </button>
//     </div>
//   );
// };

// export default WeatherMap;
// import React, { useEffect, useRef, useState } from "react";
// import L from "leaflet";
// import "leaflet/dist/leaflet.css";
// import ShadowSimulator from "leaflet-shadow-simulator";
// import "./WeatherMap.css"

// export default function SolarMap() {
//   const mapRef = useRef(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     // Default fallback: Thoothukudi

//     let defaultLat = 8.80556;
//     let defaultLng = 78.145;

//     const initMap = (lat, lng) => {
//       if (mapRef.current) return; // prevent reinit

//       mapRef.current = L.map("mapid").setView([lat, lng], 13);

//       // Base layer
//       L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
//         attribution: '&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a>',
//       }).addTo(mapRef.current);

//       // Shadow Simulator layer
//       const shadowLayer = new ShadowSimulator({
//         lat,
//         lng,
//         apiKey:"eyJhbGciOiJIUzI1NiJ9.eyJlbWFpbCI6ImxrcHJlbXBsb3llZTAxOEBnbWFpbC5jb20iLCJjcmVhdGVkIjoxNzU0ODkxMzA0NzU2LCJpYXQiOjE3NTQ4OTEzMDR9.D2eS_5l8YjejhhUvDRA9NQyxMkT_gyg968UhxxYtMlU",
//         dateTime: new Date(),
//         utcOffset: new Date().getTimezoneOffset() / -60,
//         sunpath: true, // enable sunpath display
//       });
//       shadowLayer.addTo(mapRef.current);

//       // Toggle button
//       const toggleButton = L.control({ position: "topright" });
//       toggleButton.onAdd = () => {
//         const btn = L.DomUtil.create("button", "leaflet-bar");
//         btn.innerText = "Toggle Sunpath";
//         btn.style.background = "#ff9800";
//         btn.style.color = "#fff";
//         btn.onclick = () => {
//           if (mapRef.current.hasLayer(shadowLayer)) {
//             mapRef.current.removeLayer(shadowLayer);
//           } else {
//             mapRef.current.addLayer(shadowLayer);
//           }
//         };
//         return btn;
//       };
//       toggleButton.addTo(mapRef.current);

//       setLoading(false);
//     };

//     // Try geolocation
//     if (navigator.geolocation) {
//       navigator.geolocation.getCurrentPosition(
//         (pos) => {
//           initMap(pos.coords.latitude, pos.coords.longitude);
//         },
//         () => {
//           initMap(defaultLat, defaultLng); // fallback
//         }
//       );
//     } else {
//       initMap(defaultLat, defaultLng); // fallback
//     }
//   }, []);

//   return (
//     <div className="weather-map ">
//       {loading ? (
//         <div style={{ textAlign: "center", padding: "10px" }}>Fetching location...</div>
//       ) : null}
//       <div
//         id="mapid"
//         style={{
//           height: "500px",
//           width: "100%",
//           borderRadius: "8px",
//           overflow: "hidden",
//         }}
//       ></div>
//     </div>
//   );
// }
// import React, { useEffect, useRef, useState } from "react";
// import L from "leaflet";
// import ShadeMap from "leaflet-shadow-simulator";
// import "leaflet/dist/leaflet.css";

// export default function WeatherMap() {
//   const mapRef = useRef(null);
//   const [map, setMap] = useState(null);
//   const [settings, setSettings] = useState(null);

//   useEffect(() => {
//     const savedSettings = JSON.parse(localStorage.getItem("solarSettings")) || {
//       useGPS: true,
//       defaultLat: 8.7642,
//       defaultLng: 78.1348,
//       mapStyle: "osm",
//       showSunpath: true,
//       utcOffset: new Date().getTimezoneOffset() / -60
//     };
//     setSettings(savedSettings);

//     if (savedSettings.useGPS && navigator.geolocation) {
//       navigator.geolocation.getCurrentPosition(
//         (pos) => initMap(pos.coords.latitude, pos.coords.longitude, savedSettings),
//         () => initMap(savedSettings.defaultLat, savedSettings.defaultLng, savedSettings)
//       );
//     } else {
//       initMap(savedSettings.defaultLat, savedSettings.defaultLng, savedSettings);
//     }
//   }, []);

//   const initMap = (lat, lng, settings) => {
//     if (mapRef.current && !map) {
//       const leafletMap = L.map(mapRef.current).setView([lat, lng], 13);

//       // Map style
//       let tileUrl =
//         settings.mapStyle === "satellite"
//           ? "https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png"
//           : settings.mapStyle === "dark"
//           ? "https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png"
//           : "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";

//       L.tileLayer(tileUrl, { maxZoom: 19 }).addTo(leafletMap);

//       // Add shadow simulator
//       const shadeMap = new ShadeMap({
//         date: new Date(),
//         color: "#01112f",
//         opacity: 0.5,
//         apiKey:"eyJhbGciOiJIUzI1NiJ9.eyJlbWFpbCI6ImxrcHJlbXBsb3llZTAxOEBnbWFpbC5jb20iLCJjcmVhdGVkIjoxNzU0ODkxMzA0NzU2LCJpYXQiOjE3NTQ4OTEzMDR9.D2eS_5l8YjejhhUvDRA9NQyxMkT_gyg968UhxxYtMlU",
//         terrainSource: {
//           tileSize: 256,
//           maxZoom: 15,
//           getSourceUrl: ({ x, y, z }) =>
//             `https://s3.amazonaws.com/elevation-tiles-prod/terrarium/${z}/${x}/${y}.png`,
//           getElevation: ({ r, g, b }) => r * 256 + g + b / 256 - 32768
//         }
//       }).addTo(leafletMap);

//       // Add sunpath toggle
//       if (settings.showSunpath) {
//         // In future, integrate sunpath lines here
//         console.log("Sunpath overlay ON");
//       }

//       setMap(leafletMap);
//     }
//   };

//   return <div id="mapid" ref={mapRef} style={{ height: "100vh", width: "100%" }} />;
// }
// import * as L from 'leaflet'
// import ShadeMap from 'leaflet-shadow-simulator';

// const map = L.map("mapid"); 

// const shadeMap = new ShadeMap({
//   date: new Date(),    // display shadows for current date
//   color: '#01112f',    // shade color
//   opacity: 0.7,        // opacity of shade color
//   apiKey: "XXXXXX",    // obtain from https://shademap.app/about/
//   terrainSource: {
//     tileSize: 256,       // DEM tile size
//     maxZoom: 15,         // Maximum zoom of DEM tile set
//     getSourceUrl: ({ x, y, z }) => {
//       // return DEM tile url for given x,y,z coordinates
//       return `https://s3.amazonaws.com/elevation-tiles-prod/terrarium/${z}/${x}/${y}.png`
//     },
//     getElevation: ({ r, g, b, a }) => {
//       // return elevation in meters for a given DEM tile pixel
//       return (r * 256 + g + b / 256) - 32768
//     }
//   },
// }).addTo(map);
// // advance shade by 1 hour
// shadeMap.setDate(new Date(Date.now() + 1000 * 60 * 60)); 

// // sometime later
// // ...remove layer
// shadeMap.remove();
// function WeatherMap(){
//   return(

//     <div>
      
//     </div>
//   )
// }
